import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { IdResource } from "../../../../constants/IdResource";
import { selectRecipeProductionSkipCost } from "../../../../selectors/selectRecipeInfo";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionBuildingsDeselect } from "../../../player-base/buildings/actionBuildings";
import { actionInventoryInfoRemoveResource } from "../../inventory/actionInventoryInfo";
import { actionProductionInfoFinishProduction, TypeActionProductionInfo, } from "../actionProductionInfo";
export var epicProductionSkipConfirmed = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.ProductionSkipConfirmed), switchMap(function (action) {
        var state = state$.value;
        var amount = selectRecipeProductionSkipCost(state, action.building);
        return deps
            .netSend({
            id: CommandCode.SkipProduce,
            props: {
                amount: amount,
                buildingId: action.building.proto.id,
                farmId: state.playerBase.base.baseId,
                itemId: IdResource.Gold,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            return from([
                actionInventoryInfoRemoveResource([
                    { typeId: res.itemId, amount: res.amount },
                ]),
                actionProductionInfoFinishProduction(action.building.proto.id),
                actionBuildingsDeselect(),
            ]);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epics/epicProductionSkipConfirmed.ts
// module id = 1940
// module chunks = 3